import React from "react";
import {
  Paper,
  Typography,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import Launch from "@material-ui/icons/Launch";
import ChatMessages from "./ChatMessages";
import UserList from "./UserList"; // Assurez-vous que ce chemin est correct
import IconButtonStyled from "../general/IconButtonStyled";
import ButtonStyled from "../general/ButtonStyled";

const ChatSmallView = ({
  users,
  selectedUser,
  handleSelectUser,
  handleViewScreen,
  currentUser,
  groupedMessages,
  filteredMessages,
  loadingMessages,
  newMessage,
  setNewMessage,
  handleKeyDown,
  handleSendMessage,
}) => {
  return (
    <Paper style={{ padding: "1em", maxWidth: "300px", width: "300px" }}>
      <Typography
        variant="h6"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        Messagerie
        <IconButtonStyled
          aria-describedby="full-screen"
          variant="outlined"
          onClick={() => handleViewScreen("full")}
          tooltipTitle="plein écran"
          style={{ width: 32, height: 32, padding: 5 }}
          iconSize={16}
          position="left"
        >
          <Launch />
        </IconButtonStyled>
      </Typography>
      <UserList
        variant="small"
        users={users}
        selectedUser={selectedUser}
        handleSelectUser={handleSelectUser}
      />
      {loadingMessages ? (
        <CircularProgress />
      ) : (
        <ChatMessages
          variant="small"
          groupedMessages={groupedMessages}
          filteredMessages={filteredMessages}
          currentUser={currentUser}
        />
      )}
      <TextField
        label="Votre message"
        fullWidth
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        style={{ marginTop: "1em" }}
        onKeyDown={handleKeyDown}
        variant="outlined"
      />
      <ButtonStyled
        variant="contained"
        color="primary"
        onClick={handleSendMessage}
        style={{ width: "100%" }}
      >
        Envoyer
      </ButtonStyled>
    </Paper>
  );
};

export default ChatSmallView;
